import { getSettingValueWithoutAssignment } from "@faire/help-center-utils/settings/getSetting";
import { HELP_CENTER_CHAT_MESSENGER_WINDOW_LOGO_URL_230413 } from "@faire/web-api--source/indigofair/settings/HELP_CENTER_CHAT_MESSENGER_WINDOW_LOGO_URL_230413";

export function getSettingChatMessengerWindowLogoUrl(): string {
  return getSettingValueWithoutAssignment(
    HELP_CENTER_CHAT_MESSENGER_WINDOW_LOGO_URL_230413,
    "https://cdn.faire.com/fastly/ac162790249d629c2ed28bb00d356d51bb4a058cad9c32c89fa9ba5b67840fce.png"
  );
}
